module.exports = __webpack_public_path__ + "static/media/suggestion-dictionary-guide.4204780d.png";